import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    unreadCount: 0,
    topUnread: [], // top 10 unread items from userNotifications.objects
    lastUpdatedAt: null,
};

const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setUnreadSummary(state, action) {
            const { unreadCount, topUnread } = action.payload || {};
            state.unreadCount = typeof unreadCount === "number" ? unreadCount : 0;
            state.topUnread = Array.isArray(topUnread) ? topUnread : [];
            state.lastUpdatedAt = Date.now();
        },
        resetNotifications(state) {
            state.unreadCount = 0;
            state.topUnread = [];
            state.lastUpdatedAt = Date.now();
        },
    },
});

export const notificationsActions = notificationsSlice.actions;
export default notificationsSlice.reducer;
